//NEW: UI_REVAMP
import { Box, Flex, Grid, Text } from '@chakra-ui/react';

import ImgComp from '../../utils/ImgComp';
import { useQuery } from '@tanstack/react-query';
import { getGameWinRateApi } from '../../api/query/setupApi';
import GradientBox from '../box/GradientBox';
import { currencyFormat } from '../../utils/numberFormat';
import Loading from '../../utils/Loading';

const Prize = () => {
	const getGameWinRate = useQuery(['getGameWinRateApi'], getGameWinRateApi);

	if (getGameWinRate.isLoading) return <Loading />;

	return (
		<>
			<Grid
				templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)' }}
				gap={3}
				w='full'
			>
				{getGameWinRate.data?.pkgInfo?.map((items, index) => {
					return (
						<GradientBox key={items.gameType || index} borderRadius={8}>
							<Box
								display='flex'
								justifyContent='space-between'
								alignItems='stretch'
								bgGradient='linear-gradient(180deg, #FFF 0%, #E5EDF9 100%), #D6E7FF'
								px={4}
								py={3}
								borderRadius='inherit'
								w='full'
								h='full'
							>
								<ImgComp svgName={String(items.gameType).toLowerCase()} w={75} h={75} />
								<Flex flexDir='column' justifyContent='space-between' alignItems='end'>
									<Text color='#4B4C50' fontSize={{ base: '14px', lg: '20px' }} fontWeight='500'>
										Prize
									</Text>
									<Text color='#000' fontSize={{ base: '20px', lg: '22px' }} fontWeight='600'>
										PHP {currencyFormat(items.prize)}
									</Text>
								</Flex>
							</Box>
						</GradientBox>
					);
				})}
			</Grid>
		</>
	);
};

export default Prize;
